import { type FC, PropsWithChildren, useContext } from 'react';

import { GhostModeContext } from '../../../context/GhostMode/GhostMode';
import { Wrapper } from './styled';

const PageBodyWrapper: PropsWithChildren<FC> = ({ children, ...props }): JSX.Element => {
  const { isGhostMode } = useContext(GhostModeContext);

  return (
    <Wrapper isGhostMode={isGhostMode} {...props}>
      {children}
    </Wrapper>
  );
};

export default PageBodyWrapper;
